import * as Lockr from 'lockr';

import { AppConfiguration } from '../stores/AppConfigurationStore';

import utils = egr.wcf.utils;

declare global {
    interface Navigator {
        userLanguage?: string;
    }
}

export abstract class AppLanguageHelper {
    public static getURLParameter(name: string): string | null {
        const regEx: RegExpExecArray | null = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search);
        if (regEx == null || utils.string.isNullOrEmpty(regEx[1])) {
            return null;
        }
        return decodeURIComponent(regEx[1].replace(/\+/g, '%20'));
    }

    public static getLanguage(): string | null {
        const languageByParameter: string | null = AppLanguageHelper.getURLParameter('language');
        if (utils.string.isNotNullOrEmpty(languageByParameter)) {
            return languageByParameter;
        }
        if (utils.string.isNotNullOrEmpty(Lockr.get('language'))) {
            return Lockr.get('language');
        }
        if (utils.string.isNotNullOrEmpty(navigator.language)) {
            return navigator.language.substr(0, 2);
        }
        if (utils.string.isNotNullOrEmpty(navigator.userLanguage)) {
            return navigator.userLanguage.substr(0, 2);
        }
        return null;
    }

    public static getValidLanguage(fallback?: string): string {
        const language: string | null = AppLanguageHelper.getLanguage();
        if (utils.string.isNotNullOrEmpty(language) && AppConfiguration.AllowedLanguages.indexOf(language) !== -1) {
            return language;
        }
        return utils.string.isNotNullOrEmpty(fallback) ? fallback : 'en';
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/AppLanguageHelper.ts